/**
 * Ton-Vertrag für alle Pillen (Story 26.17, [RUDOLF] 01.11.2026): Pillen dürfen leicht farbig sein – nur wo es Sinn
 * ergibt und systemweit gleich (Zahlungseingänge wie Offene Posten). Töne nach Bedeutung als Stufenleiter aus den
 * Pastell-Tokens (hell und kühl-dunkel), sonst grau:
 *
 * - `ready`   grün     – passt, erledigt, erfüllt
 * - `notice`  gelb     – Vorstufe vor jeder Mahnung: früh, leicht, bald fällig (Liefertermin naht)
 * - `check`   bernstein – prüfen, fällig, Zahlungserinnerung
 * - `escalate` orange  – Eskalation, 1. Mahnung (sparsam)
 * - `clarify` rot      – Problem, Klärfall, überfällig, 2. Mahnung
 * - `critical` dunkelrot – letzte Eskalation: nur Inkasso (sonst nur nach Rückfrage bei Rudolf)
 * - `info`    blau     – Information, KI-Vorschlag
 * - `neutral` grau     – reine Angaben, Filter, Ansichten, Mengen
 *
 * Nie Farbe allein: Wort oder Zeichen (✓, ToneMark) bleiben immer stehen. Seiten wählen nur die Bedeutung; Fläche und
 * Schrift kommen nur von hier. Kontrast der Schrift auf der Fläche ≥ 4,5 : 1 in hell und dunkel (axe).
 */
export const PILL_TONES = ['ready', 'notice', 'check', 'escalate', 'clarify', 'critical', 'info', 'neutral'] as const;
export type PillTone = (typeof PILL_TONES)[number];

const SURFACE: Readonly<Record<PillTone, string>> = {
  ready: 'bg-ready-bg text-ready',
  notice: 'bg-notice-bg text-notice',
  check: 'bg-check-bg text-check',
  escalate: 'bg-escalate-bg text-escalate',
  clarify: 'bg-clarify-bg text-clarify',
  critical: 'bg-critical-bg text-critical',
  info: 'bg-info-bg text-info',
  neutral: 'bg-fill text-ink-2',
};

/** Fläche und Schrift einer Pille im Ton (ohne Größe und Form – die setzt der Baustein). */
export function pillToneClass(tone: PillTone): string {
  return SURFACE[tone];
}

const DOT: Readonly<Record<PillTone, string>> = {
  ready: 'bg-ready',
  notice: 'bg-notice',
  check: 'bg-check-dot',
  escalate: 'bg-escalate',
  clarify: 'bg-clarify',
  critical: 'bg-critical',
  info: 'bg-info',
  neutral: 'bg-ink-3',
};

/** Farbe eines kleinen Punkts im selben Ton (Zusatz zum Wort, nie allein). */
export function pillDotClass(tone: PillTone): string {
  return DOT[tone];
}

/** Grundform der Standard-Pille: eine Höhe (`--pill-h`), voll gerundet, kleine Schrift, kein Umbruch. */
export const PILL_BASE = 'inline-flex h-pill-h flex-none items-center gap-space-1 rounded-pill px-space-2 text-pill font-medium whitespace-nowrap';
